export default __webpack_public_path__ + "7e1beb7adf93188e44880978cf57868b.svg";